var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.65496 3.12783C6.01285 2.35446 7.11215 2.35446 7.47004 3.12783L8.0276 4.3327C8.16801 4.63611 8.45076 4.84929 8.78109 4.90079L10.1314 5.11132C10.9312 5.23601 11.2592 6.20967 10.6978 6.79286L9.64294 7.88882C9.42504 8.1152 9.32622 8.43083 9.3761 8.74105L9.61361 10.2182C9.74642 11.0442 8.8667 11.6584 8.13706 11.2491L7.05173 10.6403C6.74785 10.4698 6.37715 10.4698 6.07327 10.6403L4.98794 11.2491C4.2583 11.6584 3.37858 11.0442 3.51139 10.2182L3.7489 8.74105C3.79878 8.43083 3.69996 8.1152 3.48206 7.88882L2.42717 6.79286C1.86584 6.20967 2.19382 5.23601 2.9936 5.11132L4.34391 4.90079C4.67424 4.84929 4.95699 4.63611 5.0974 4.3327L5.65496 3.12783Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.aab6b3542c284925502ab8387945be1e.svg";
export { ForwardRef as ReactComponent };